import React, { useState } from 'react'
import './styles.scss'
import { AutofitIFrame } from '@ta-interaktiv/react-autofit-iframe'
import Toggle from 'react-toggle'
import DataWrapperChart from 'components/DataWrapperChart'

const checkIsMobile = window.innerWidth <= 599

export const DeathVaccTableU60 = () => {
  const [isCurrentWave, setCurrentWave] = useState<boolean>(false)

  return (
    <div className='graphic chart' id='deathVaccToggle'>
      <h3>
        Covid-Spitaleintritte, -Todesfälle bei <nobr>20–59-Jährigen</nobr> und
        Anteile Geimpfte davon
      </h3>
      <div className='toggleWrapper'>
        <div className='center'>
          <div className={'label ' + (!isCurrentWave ? '' : 'off')}>
            Spitaleintritte
          </div>
          <div className='toggleContainer'>
            <Toggle
              defaultChecked={isCurrentWave}
              icons={false}
              onChange={() => {
                setCurrentWave(!isCurrentWave)
              }}
            />
          </div>
          <div className={'label right ' + (isCurrentWave ? '' : 'off')}>
            Todesfälle
          </div>
        </div>
      </div>

      <div
        className='switchMap'
        style={{ position: 'relative', display: 'block' }}
      >
        <div
          style={{
            opacity: !isCurrentWave ? '0' : '1.0',
            position: 'absolute',
            top: '0',
            zIndex: !isCurrentWave ? 1 : 99,
            width: '100%'
          }}
        >
          <AutofitIFrame
            src='//datawrapper.dwcdn.net/gBe1t/'
            // style={{ height: (checkIsMobile ? '490px' : '460px')}}
          />
          {/* <DataWrapperChart chartId='EQ9Ye' height={504} /> */}
        </div>
        <div
          style={{
            opacity: isCurrentWave ? '0' : '1.0',
            position: 'relative',
            top: '0',
            zIndex: !isCurrentWave ? 99 : 1,
            width: '100%'
          }}
        >
          <AutofitIFrame
            src='//datawrapper.dwcdn.net/dpoTQ'
            // style={{ height: (checkIsMobile ? '490px' : '460px')}}
          />
          {/* <DataWrapperChart chartId='TSG3x' height={504} /> */}
        </div>
      </div>
    </div>
  )
}
